exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sr-qiankun-add .searchPage[data-v-394d5dbc]{display:flex;justify-content:space-between}.sr-qiankun-add .searchRightBtn[data-v-394d5dbc]{display:inline-block}.sr-qiankun-add .searchRightBtn button[data-v-394d5dbc]{width:76px;height:32px;border-radius:16px;padding:5px 24px}.sr-qiankun-add .tabsLabel[data-v-394d5dbc]{font-size:16px;font-family:PingFangSC-Medium,PingFang SC;font-weight:500;color:#333;line-height:24px}.sr-qiankun-add .tabsLabel i[data-v-394d5dbc]{margin-right:4px}.sr-qiankun-add ::v-deep .el-tabs__header[data-v-394d5dbc]{margin-bottom:16px!important}.sr-qiankun-add .tabsDataTitle[data-v-394d5dbc]{margin-top:8px;font-family:PingFangSC-Medium,PingFang SC;font-weight:600;color:#333;line-height:22px;margin-bottom:13px;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-394d5dbc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./packages/SrQiankunAdd/SrQiankunAdd.vue
// module id = 244
// module chunks = 0